
import TrackerDelete from './tracker-delete.vue'
import TrackerSegment from './tracker-segment.vue'
import TrackerButtongroup from './tracker-buttongroup.vue'
import TrackerSlider from './tracker-slider.vue'
import TrackerTextarea from './tracker-textarea.vue'
import RolesSelector from './roles-selector.vue'
import {markRaw} from 'vue'
import $companies from 'stores/companies'
import $contacts2, {$contacts_groups} from 'stores/contacts2'
import {sliderFocus} from '../pulse-defs'
import {PERSON_ALERTS} from 'consts/tracker'
import ContactTile from '../contact-tile.vue'

export default {
  components: {TrackerDelete, TrackerSegment, TrackerButtongroup, TrackerSlider, TrackerTextarea, RolesSelector, ContactTile},
  props: {
    companyId: {
      type: String,
      default: undefined
    },
    contactId: {
      type: String,
      required: true
    },
    head: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      alerts: markRaw(PERSON_ALERTS),
      company: undefined,
      contact: undefined
    }
  },
  computed:{
    loading(){
      return this.contact == undefined
    },
    saving(){
      return this.contact?.saving
    },
    tracker_focus: {
      get() {
        return this.contact.tracker_focus
      }, 
      set(val) {
        this.contact.tracker_focus = val
      }
    },
    slider_focus: sliderFocus(),
    focus_text() {
      return !!this.contact?.focus_on?.trim()
    },
    can_save(){
      return this.contact.changed
    }
  },
  mounted(){
    this.$debounce_175(this.init)
  },
  beforeUnmount() {
    $contacts_groups.abortAll()
    $contacts2.abortAll()
  },
  methods: {
    async init(){
      if (this.companyId) {
        this.company = await $companies.loadCompany(this.companyId)
      }
      this.contact = await $contacts2.loadContact(this.contactId)
    },
    openDeleteModal(){
      this.$refs.delete.open(this.contact)
    },
    async onSave(){
      await this.contact.save()
      $contacts_groups.updateContact(this.contact.state_copy)
      this.$dispatch('save', this.contact)
    },
    onDeleted(){
      if (!this.company) return
      $contacts_groups.deleteContact(this.contact)
    }
  }
}
